var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstaAdriaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 329.9 313.7",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#338E9B",
    points: "164.8,77.6 139.6,0.1 139.6,0 110.3,90.1 110.3,90.1 15.6,90.1 15.6,90.1 81.7,138.1 145.2,138.1  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#338E9B",
    points: "248.1,138.1 314.2,90.1 314.2,90.1 219.5,90.1 219.5,90.1 190.2,0 165,77.6 184.7,138.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#338E9B",
    points: "216.5,236 282.5,283.9 282.5,284 253.3,193.9 253.2,193.9 329.9,138.2 248.4,138.2 196.9,175.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#25B0C0",
    points: "113.5,236.3 88.3,313.7 88.3,313.7 165,258.1 164.9,258.1 241.6,313.7 241.6,313.7 216.4,236.3  164.9,198.9 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#338E9B",
    points: "76.6,193.9 47.4,284 47.4,284 113.4,236 133,175.7 81.5,138.2 0.1,138.2 0,138.3 76.6,193.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstaAdriaLogo);
export default __webpack_public_path__ + "static/media/Asta-Adria-logo.a9b60947c739e5c0a26c88895e4ddb8c.svg";
export { ForwardRef as ReactComponent };